<div class="eon-dropdown-menu" [class.-active]="isDropDownShown">
  <div class="dropdown-value" (click)="toggleDropDown()">
    <span class="fa fa-map-marker fa-lg"></span>
    <div class="select">{{ selectedItem?.displayName }}</div>
    <span class="fa fa-chevron-down chevron fa-lg"></span>
  </div>

  <div class="dropdown-hover" *ngIf="isDropDownShown">
    <div class="dropdown-value" (click)="toggleDropDown()">
      <span class="fa fa-map-marker fa-lg"></span>
      <div class="select">{{ selectedItem?.displayName }}</div>
      <span class="fa fa-chevron-down chevron fa-lg"></span>
    </div>

    <div class="dropdown-content">
      <hr class="divider" />
      <app-dropdown-selection
        class="dropdown-section"
        [items]="items"
        [selectedItem]="selectedItem"
        [buttonToggleText]="buttonToggleText"
        (itemSearch)="itemSearch($event)"
        (selectedItemChange)="selectItem($event)"
      ></app-dropdown-selection>
    </div>
  </div>
</div>
